import { RefCustomerListConfigService } from './services/ref-customer-list-config/ref-customer-list-config.service';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, Inject } from '@angular/core';

import { RefAppComponent } from './ref-app.component';
import { RouterModule } from '@angular/router';
import {
  GungStandardModule,
  createTranslateLocalLoader,
  TranslationLocalService,
  CacheInterceptorService,
  BackendInterceptor,
  ProductListConfigService,
  CheckoutConfigService,
  CustomerService,
  CustomerListConfigService,
  OrderService,
  CartService,
  ProductService,
  SalesCartConfigService,
  CartConfigService,
  OrderListConfigService
} from 'gung-standard';
import {
  GungStandardJeevesModule,
  JeevesModalService,
  JeevesOpenOrdersListTableConfigService,
  JeevesCustomerActionConfigService,
  JeevesOrderListConfigService,
  JeevesInvoiceListConfigService
} from 'gung-standard-jeeves';
import { environment } from '../environments/environment';
import { GungDashboardModule, DashboardCardService } from 'gung-dashboard';
import { GungListModule } from 'gung-list';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { RefBackendInterceptorService } from '../services/ref-backend-interceptor.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RefWrapperComponent } from './components/ref-wrapper/ref-wrapper.component';
import { FooterComponent } from './components/ref-footer/ref-footer.component';
import { RefWelcomeComponent } from './components/pages/ref-welcome/ref-welcome.component';
import { RefCategoriesComponent } from './components/pages/ref-categories/ref-categories.component';
import { RefProductsComponent } from './components/pages/ref-products/ref-products.component';
import { RefProductListConfigService } from './services/ref-product-list-config/ref-product-list-config.service';
import { RefCustomersComponent } from './components/pages/ref-customers/ref-customers.component';
import { RefCustomerDetailsComponent } from './components/pages/ref-customer-details/ref-customer-details.component';
import { RefNavbarComponent } from './components/ref-navbar/ref-navbar.component';
import { RefJeevesModalService } from './services/ref-jeeves-modal/ref-jeeves-modal.service';
import { RefTranslationLocalService } from './services/ref-translation-local/ref-translation-local.service';
import { RefJeevesAddCustomerModalComponent } from './components/ref-jeeves-add-customer-modal/ref-jeeves-add-customer-modal.component';
import { RefJeevesProductTableComponent } from './components/ref-jeeves-product-table/ref-jeeves-product-table.component';
import { RefProductDetailsComponent } from './components/pages/ref-product-details/ref-product-details.component';
import { RefCheckoutDefaultsComponent } from './components/ref-checkout-defaults/ref-checkout-defaults.component';
import { RefCheckoutConfigService } from './services/ref-checkout-config.service';
import { RefMessageModalComponent } from './components/ref-message-modal/ref-message-modal.component';
import { RefCustomerService } from './services/ref-customer/ref-customer.service';
import { CapstoneCustomerListCardComponent } from './components/capstone/capstone-customer-list-card/capstone-customer-list-card.component';
import { getDefaultConfiguration } from './utilities/default-configurations';
import { RefJeevesCustomerDetailsComponent } from './components/ref-jeeves-customer-details/ref-jeeves-customer-details.component';
import { RefJeevesOpenOrdersListTableConfigService } from './services/ref-jeeves-open-orders-list-table-config/ref-jeeves-open-orders-list-table-config.service';
import { RefJeevesOpenOrdersComponent } from './components/ref-jeeves-open-orders/ref-jeeves-open-orders.component';
import { DOCUMENT } from '@angular/common';
import { RefOrderTermsJeevesComponent } from './components/checkout/steps/ref-order-terms-jeeves/ref-order-terms-jeeves.component';
import { RefCustomersOrderedTwoMonthsComponent } from './components/dashboard/ref-customers-ordered-two-months/ref-customers-ordered-two-months.component';
import { RefCustomersOrderedFiveMonthsComponent } from './components/dashboard/ref-customers-ordered-five-months/ref-customers-ordered-five-months.component';
import { RefDashboardCardService } from './services/ref-dashboard/ref-dashboard-card.service';
import { RefFilterCardConfigService } from './services/ref-dashboard/ref-filter-card-config.service';
import { RefInvoiceStatisticsComponent } from './components/dashboard/ref-invoice-statistics/ref-invoice-statistics.component';
import { RefCartService } from './services/ref-cart/ref-cart.service';
import { RefProductService } from './services/ref-product/ref-product.service';
import { RefJeevesSalesCartListComponent } from './components/checkout/ref-jeeves-sales-cart-list/ref-jeeves-sales-cart-list.component';
import { RefJeevesSalesCartConfigService } from './services/ref-jeeves-sales-cart-config/ref-jeeves-sales-cart-config.service';
import { RefSalesCartListComponent } from './components/cart/ref-sales-cart-list/ref-sales-cart-list/ref-sales-cart-list.component';
import { RefSalesCartConfigService } from './services/cart/ref-sales-cart-config.service';
import { RefProductCommodityChartComponent } from './components/dashboard/ref-product-commodity-chart/ref-product-commodity-chart.component';
import { NgChartsModule } from 'ng2-charts';
import { RefJeevesCustomerActionConfigService } from './services/ref-jeeves-customer-action-config/ref-jeeves-customer-action-config.service';
import { RefJeevesEditCustomerModalComponent } from './components/ref-jeeves-edit-customer-modal/ref-jeeves-edit-customer-modal.component';
import { RefNavbarcartComponent } from './components/ref-navbarcart/ref-navbarcart.component';
import { RefDeliveryLocationsJeevesComponent } from './components/ref-delivery-locations-jeeves/ref-delivery-locations-jeeves.component';
import { RefCartItemComponent } from './components/cart/ref-cart-item/ref-cart-item.component';
import { RefCartConfigService } from './services/cart/ref-cart-config.service';
import { RefCartListLayoutComponent } from './components/cart/ref-cart-list-layout/ref-cart-list-layout.component';
import { RefJeevesOrderListConfigService } from './services/ref-jeeves-order-list-config/ref-jeeves-order-list-config.service';
import { RefJeevesInvoiceListConfigService } from './services/ref-jeeves-invoice-list-config/ref-jeeves-invoice-list-config.service';
import { RefJeevesInvoiceListComponent } from './components/ref-jeeves-invoice-list/ref-jeeves-invoice-list.component';
import { RefJeevesProductGridViewComponent } from './components/ref-jeeves-product-grid-view/ref-jeeves-product-grid-view.component';
import { CapstoneDeliveryAddressStepComponent } from './components/capstone/capstone-delivery-address-step/capstone-delivery-address-step.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GungCommonModule } from 'gung-common';
import { CapstoneOrderDetailsComponent } from './components/capstone/capstone-order-details/capstone-order-details.component';
import { RefOpenOrderTableComponent } from './components/ref-open-order-table/ref-open-order-table.component';
import { RefOrderDetailsComponent } from './components/ref-order-details/ref-order-details.component';
import { RefOrderCardListComponent } from './components/ref-order-card-list/ref-order-card-list.component';
import { RefButtonsComponent } from './components/checkout/ref-buttons/ref-buttons.component';

@NgModule({ declarations: [
        RefAppComponent,
        RefWrapperComponent,
        FooterComponent,
        RefWelcomeComponent,
        RefCategoriesComponent,
        RefProductsComponent,
        RefCustomersComponent,
        RefCustomerDetailsComponent,
        RefNavbarComponent,
        RefJeevesAddCustomerModalComponent,
        RefJeevesProductTableComponent,
        RefProductDetailsComponent,
        RefCheckoutDefaultsComponent,
        RefMessageModalComponent,
        CapstoneCustomerListCardComponent,
        RefJeevesCustomerDetailsComponent,
        RefJeevesOpenOrdersComponent,
        RefOrderTermsJeevesComponent,
        RefCustomersOrderedTwoMonthsComponent,
        RefCustomersOrderedFiveMonthsComponent,
        RefInvoiceStatisticsComponent,
        RefJeevesSalesCartListComponent,
        RefSalesCartListComponent,
        RefProductCommodityChartComponent,
        RefJeevesEditCustomerModalComponent,
        RefNavbarcartComponent,
        RefDeliveryLocationsJeevesComponent,
        RefCartItemComponent,
        RefCartListLayoutComponent,
        RefJeevesInvoiceListComponent,
        RefJeevesProductGridViewComponent,
        CapstoneDeliveryAddressStepComponent,
        CapstoneOrderDetailsComponent,
        RefOpenOrderTableComponent,
        RefOrderDetailsComponent,
        RefOrderCardListComponent,
        RefButtonsComponent
    ],
    bootstrap: [RefAppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        GungCommonModule,
        GungStandardModule,
        GungDashboardModule,
        GungStandardJeevesModule,
        GungListModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLocalLoader,
                deps: [TranslationLocalService]
            }
        }),
        NgChartsModule], providers: [
        { provide: 'environment', useValue: environment },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RefBackendInterceptorService,
            multi: true
        },
        {
            provide: ProductService,
            useClass: RefProductService
        },
        {
            provide: BackendInterceptor,
            useClass: RefBackendInterceptorService
        },
        {
            provide: ProductListConfigService,
            useClass: RefProductListConfigService
        },
        {
            provide: JeevesModalService,
            useClass: RefJeevesModalService
        },
        {
            provide: TranslationLocalService,
            useClass: RefTranslationLocalService
        },
        {
            provide: CheckoutConfigService,
            useClass: RefCheckoutConfigService
        },
        {
            provide: CustomerService,
            useClass: RefCustomerService
        },
        {
            provide: CustomerListConfigService,
            useClass: RefCustomerListConfigService
        },
        {
            provide: JeevesOpenOrdersListTableConfigService,
            useClass: RefJeevesOpenOrdersListTableConfigService
        },
        {
            provide: DashboardCardService,
            useClass: RefDashboardCardService
        },
        // {
        //   provide: FilterCardService,
        //   useClass: RefFilterCardConfigService
        // },
        {
            provide: CartService,
            useClass: RefCartService
        },
        {
            provide: SalesCartConfigService,
            useClass: RefSalesCartConfigService
        },
        {
            provide: JeevesCustomerActionConfigService,
            useClass: RefJeevesCustomerActionConfigService
        },
        {
            provide: CartConfigService,
            useClass: RefCartConfigService
        },
        {
            provide: OrderListConfigService,
            useClass: RefJeevesOrderListConfigService
        },
        {
            provide: JeevesInvoiceListConfigService,
            useClass: RefJeevesInvoiceListConfigService
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class RefAppModule {
  constructor(translate: TranslateService, private titleService: Title, @Inject(DOCUMENT) private document: Document) {
    this.setFavicon(getDefaultConfiguration().faviconLocation);

    this.titleService.setTitle(getDefaultConfiguration().title);

    const lang = localStorage.getItem('selectedLanguage');
    translate.use(lang || getDefaultConfiguration().language);
  }

  private setFavicon(location: string): void {
    if (!location) {
      return;
    }

    this.document.getElementById('link-apple-icon-57-57').setAttribute('href', location + '/apple-icon-57x57.png');
    this.document.getElementById('link-apple-icon-60-60').setAttribute('href', location + '/apple-icon-60x60.png');
    this.document.getElementById('link-apple-icon-72-72').setAttribute('href', location + '/apple-icon-72x72.png');
    this.document.getElementById('link-apple-icon-76-76').setAttribute('href', location + '/apple-icon-76x76.png');
    this.document.getElementById('link-apple-icon-114-114').setAttribute('href', location + '/apple-icon-114x114.png');
    this.document.getElementById('link-apple-icon-120-120').setAttribute('href', location + '/apple-icon-120x120.png');
    this.document.getElementById('link-apple-icon-144-144').setAttribute('href', location + '/apple-icon-144x144.png');
    this.document.getElementById('link-apple-icon-152-152').setAttribute('href', location + '/apple-icon-152x152.png');
    this.document.getElementById('link-apple-icon-180-180').setAttribute('href', location + '/apple-icon-180x180.png');
    this.document
      .getElementById('link-android-icon-192-192')
      .setAttribute('href', location + '/android-icon-192x192.png');
    this.document.getElementById('link-favicon-32-32').setAttribute('href', location + '/favicon-32x32.png');
    this.document.getElementById('link-favicon-96-96').setAttribute('href', location + '/favicon-96x96.png');
    this.document.getElementById('link-favicon-16-16').setAttribute('href', location + '/favicon-16x16.png');
    this.document.getElementById('link-manifest').setAttribute('href', location + '/manifest.json');
    this.document.getElementById('meta-ms-icon').setAttribute('content', location + '/ms-icon-144x144.png');
  }
}
